/**
 * denials module route path constants.
 *
 * Mirrors `modules/claims/routes/routeConfig.ts`: all denials paths are declared here so App
 * routing, in-app navigation, and path builders share one source of truth.
 */
export const DENIALS_BASE_PATH = '/denials';
export const DENIALS_QUEUE_PATH = '/denials/queue';
export const DENIALS_WORKLIST_PATH = '/denials/worklist';
export const DENIALS_ITEM_PATH = '/denials/items/:itemId';
export const DENIALS_RUN_REPORT_PATH = '/denials/reports/run';
export const DENIALS_REPORT_PATH = '/denials/reports/denials';
export const DENIALS_ADMIN_PATH = '/denials/admin';
export const DENIALS_RULES_PATH = '/denials/rules';
export const DENIALS_NEEDS_INFO_PATH = '/denials/needs-info';

/** One queue's worklist, named in the query string the way the Medical Necessity worklist is. */
export const denialsWorklistPath = (targetQueue: string): string =>
  `${DENIALS_WORKLIST_PATH}?queue=${encodeURIComponent(targetQueue)}`;

/** Retired Denied Claims worklist path, kept only to redirect a bookmark (US4). */
export const LEGACY_DENIAL_WORKLIST_PATH = '/appeals/denials';
/** Retired Denied Claims detail path, kept only to redirect a bookmark (US4). */
export const LEGACY_DENIAL_DETAIL_PATH = '/appeals/denials/:remitId/:claimIndex';
